import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { FLEX } from '@v4/constants/quiz'
import clsx from 'clsx'
import WhiteThemeProvider from '@v4/components/sections/Question/Components/WhiteThemeProvider'
import SubmitButton from '../../components/SubmitButton'
import OptionList from './components/OptionList'
import { useMultipleChoiceButtons } from './MultipleChoiceButtons.hooks'

const MultipleChoiceButtons = props => {
	const [
		{
			classes,
			justify,
			options,
			pending,
			selectedOptions,
			gridWidth,
			withEdition,
			type,
			multiple,
			isDragging,
			otherOptionId,
			otherAnswer,
		},
		{
			handleClick,
			handleChange,
			handleAdd,
			handleDelete,
			handleSubmit,
			handleSortStart,
			handleSortEnd,
			handleOtherChange,
		},
	] = useMultipleChoiceButtons(props)
	return (
		<>
			<WhiteThemeProvider enabled={multiple || !!otherAnswer}>
				<OptionList
					className={isDragging ? classes.dragging : undefined}
					justify={justify}
					items={options}
					pending={pending}
					selectedOptions={selectedOptions}
					gridWidth={gridWidth}
					withEdition={withEdition}
					type={type}
					onClick={handleClick}
					onChange={handleChange}
					onAdd={handleAdd}
					onDelete={handleDelete}
					useDragHandle
					draggable={withEdition}
					axis="xy"
					onSortStart={handleSortStart}
					onSortEnd={handleSortEnd}
					helperClass={clsx(classes.sortableHelper, 'sortable-helper')}
					otherOptionId={otherOptionId}
					multiple={multiple}
					onOtherChange={handleOtherChange}
					otherAnswer={otherAnswer}
				/>
			</WhiteThemeProvider>
			{multiple && (
				<Box className="q-buttons-button-container" display="flex" mt={3.75} justifyContent={justify}>
					<SubmitButton loading={pending} className="q-buttons-button" onClick={handleSubmit} />
				</Box>
			)}
		</>
	)
}

MultipleChoiceButtons.propTypes = {
	questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	onClick: PropTypes.func,
	justify: PropTypes.oneOf(Object.values(FLEX)),
	pending: PropTypes.bool,
	answers: PropTypes.array,
	shadow: PropTypes.bool,
	useOldCheckboxes: PropTypes.bool,
}

MultipleChoiceButtons.defaultProps = {
	pending: false,
	justify: FLEX.START,
	onClick: () => {},
}

export default memo(MultipleChoiceButtons)
